//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Icon',
  props: {
    name: {
      type: String,
      default: '',
    },
    size: {
      default: 'm',
      validator(value) {
        return ['xs', 's', 'm', 'l', 'xl', 'xxl', 'xxxl'].indexOf(value) !== -1;
      },
    },
    color: {
      type: String,
      default: '',
    }, // название css переменной color-colors-actions-color-2
    stroke: {
      // режим, при котором будет изменяться свойство stroke, а не fill
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      styles: {},
    };
  },
  created() {
    if (this.color) {
      if (this.stroke) {
        this.styles['--stroke'] = `var(--${this.color})`;
      } else {
        this.styles['--fill'] = `var(--${this.color})`;
      }
    }
  },
};
